import {Product} from 'services/entities/products';
import {callAPI} from 'services/api';
import {CurrencyAmount} from 'util/currency';
import {readCurrency} from 'services/currency';
import {getCacheItem, setCacheItem} from 'util/cache';

function readProductPrice(data: any): CurrencyAmount {
  const currency = readCurrency(data.currency);
  return CurrencyAmount.parse(data.price, currency);
}

function readProduct(data: any): Product {
  const {max_quantity, prices, ...props} = data;
  return {
    prices: prices.map(readProductPrice),
    maxQuantity: max_quantity,
    ...props
  };
}

export async function loadSpaceProducts(space: string): Promise<Product[]> {
  // TODO: check for concurrent requests to same endpoint
  const cacheKey = `spaces.${space}.products`;
  let products = getCacheItem(cacheKey);
  if(products) {
    return products;
  }
  const response = await callAPI(`/spaces/${space}/products/`, 'GET', null, true);
  products = response.map(readProduct);
  setCacheItem(cacheKey, products);
  return products;
}